import React from 'react'
import { scaleLinear } from 'd3-scale'
import { line, curveCardinal } from 'd3-shape'
import { extent } from 'd3-array'
import { wordwrap } from 'd3-jetpack'

const LineChart = ({ props }) => {
  // const { width, height } = props
  const width = props.width
  const height = props.height

  const margin = {
    top: 50,
    right: 50,
    bottom: 50,
    left: 50
  }

  const w = width - margin.right - margin.left
  const h = height - margin.top - margin.bottom

  const data = [0, 1, 2].map(j => ({
    meta: Object.entries(props.data.Data[j]).slice(0, 4),
    series: Object.values(props.data.Data[j])
      .slice(4, Object.values(props.data.Data[j]).length - 1)
      .map((d, i) => ({
        year: 1998 + i,
        amount: d
      }))
  }))

  const x = scaleLinear()
    .domain(extent(data[0].series, d => d.year))
    .range([0, w])

  const y = scaleLinear()
    .domain(extent(data.map(d => d.series.map(d => d.amount)).flat()))
    .range([h, 0])

  const f = d =>
    `'${d - Math.floor(d / 100) * 100 < 10 ? '0' : ''}${d -
      Math.floor(d / 100) * 100}`

  const l = line()
    .x(d => x(d.year))
    .y(d => y(d.amount))
    .curve(curveCardinal)

  return (
    <div>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <g className='y-axis'>
            {/* <line y1={y.range()[0]} y2={y.range()[1]} stroke='#999' /> */}
            {y
              .nice()
              .ticks(5)
              .map(d => (
                <g key={`y-tick-${d}`} transform={`translate(0, ${y(d)})`}>
                  <line
                    x1={x.range()[0]}
                    x2={x.range()[1]}
                    stroke='#ccc'
                    style={{ strokeWidth: 0.5 }}
                  />
                  <text
                    dx={-5}
                    style={{
                      fontSize: '12px',
                      textAnchor: 'end',
                      dominantBaseline: 'central'
                    }}
                  >
                    {d / 1000000000}
                  </text>
                </g>
              ))}
            <text
              transform={`translate(${x.range()[0]}, ${(y.range()[0] +
                y.range()[1]) /
                2}) rotate(-90)`}
              style={{
                textAnchor: 'middle',
                fontSize: 12
              }}
              dy={-30}
            >
              {props.billions}
            </text>
          </g>
          <g className='lexft-axis' transform={`translate(0, ${y.range()[0]})`}>
            {/* <line x1={x.range()[0]} x2={x.range()[1]} stroke='#999' /> */}
            {x.ticks().map(d => (
              <g key={`x-tick-${d}`} transform={`translate(${x(d)}, 0)`}>
                <text
                  dy={20}
                  style={{
                    fontSize: '12px',
                    textAnchor: 'middle'
                  }}
                >
                  {w < 450 ? f(d) : d}
                </text>
              </g>
            ))}
          </g>
          {data.map((d, i) => (
            <g key={`series-${i}`}>
              <path
                id={`series-${i}`}
                d={l(d.series)}
                fill='none'
                stroke={i === 0 ? 'red' : i === 1 ? 'steelblue' : 'green'}
                style={{
                  strokeWidth: i === 0 ? 3 : 2,
                  strokeDasharray: i === 0 ? '' : '1 1'
                }}
              />
              <text
                fill={i === 0 ? 'red' : i === 1 ? 'steelblue' : 'green'}
                style={{
                  textAnchor: 'end',
                  fontSize: 12,
                  fontWeight: 'bold'
                }}
              >
                {/* {wordwrap(d.meta[2][1], 15).map((token, j) => ( */}
                {wordwrap(
                  d.meta[3][1] === 'BX.TRF.PWKR.CD.DT'
                    ? props.prr
                    : d.meta[3][1] === 'DT.ODA.ALLD.CD'
                    ? props.netOda
                    : props.fdi,
                  15
                ).map((token, j) => (
                  <tspan
                    key={`token-${j}`}
                    dy={(i === 2 ? -50 : -30) + j * 12}
                    x={
                      i === 1
                        ? x(2009.2)
                        : x(d.series[d.series.length - 1].year)
                    }
                    y={
                      i === 1
                        ? y(2200000000)
                        : y(d.series[d.series.length - 1].amount)
                    }
                  >
                    {token}
                  </tspan>
                ))}
              </text>
            </g>
          ))}
        </g>
      </svg>
    </div>
  )
}

export default LineChart
